<template>
  <el-dialog v-loading="loading.dialog" class="meet_model_dialog" top="5vh" center :title="newTitle" width="80%"
             :before-close="handleClose" :visible.sync="dialogVisible" :append-to-body="isCreate" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form" :disabled="isedit">
      <el-form-item v-if="!checkDataInfo.id" label="主题" prop="title" :label-width="formLabelWidth">
        <el-input v-model="form.title" autocomplete="off"></el-input>
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="类型" prop="type" :label-width="formLabelWidth">
          <el-select filterable v-model="form.type" placeholder="请选择类型" :disabled="isedit">
            <el-option v-for="(item, index) in meetingType" :key="index" :label="item"
                       :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发起人" prop="leaderId" :label-width="formLabelWidth">
          <el-select filterable v-model="form.leaderId" placeholder="请选择发起人" :disabled="isedit">
            <el-option v-for="(item, index) in allUserList.ALLUSERTYPE1" :key="index" :label="item"
                       :value="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="阶段" prop="stage" :label-width="formLabelWidth">
          <div style="width: 100px;">
            {{stageType[form.stage]}}
          </div>
<!--          <el-select filterable v-model="form.stage" placeholder="请选择阶段" :disabled="true">
            <el-option v-for="(item, index) in stageType" :key="index" :label="item"
                       :value="index" />
          </el-select>-->
        </el-form-item>
      </div>
      <div>
        <el-form-item label="参会人员" prop="followerIds" :label-width="formLabelWidth">
          <el-select  style="width: 90%;" autocomplete="off" size="mini" v-model="form.followerIds"  multiple filterable  placeholder="请选择参会人员" :disabled="isedit">
            <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value" />
          </el-select>
        </el-form-item>
      </div>
<!--      <el-form-item label="记录时间" prop="serach_plt_time" :label-width="formLabelWidth">
        <el-date-picker
            v-model="form.serach_plt_time"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :disabled="isedit"/>
      </el-form-item>-->
      <div style="display: flex">
      <el-form-item label="开始时间" prop="start_date" :label-width="formLabelWidth">
        <el-date-picker
            v-model="form.start_date"
            type="date"
            value-format="yyyy-MM-dd"
            range-separator="-"
            placeholder="开始日期"
            :disabled="isedit"/>
      </el-form-item>
        <el-form-item style="margin-left: 20px;" prop="start_time">
          <el-time-select
              @change="changeTime('start')"
              placeholder="起始时间"
              v-model="form.start_time"
              :picker-options="{
      start: '08:30',
      step: '00:15',
      end: '18:30'
    }">
          </el-time-select>
<!--          <el-time-picker v-model="form.start_time"
                          value-format="HH:mm:ss"
              :picker-options="{
      selectableRange: '09:00:00 - 20:00:00'
    }"
              placeholder="开始时间">
          </el-time-picker>-->
        </el-form-item>
      </div>
      <div v-if="hour != 4 && form.start_time && !this.isUpdate">
        <el-form-item label="时长" prop="hour" :label-width="formLabelWidth">
          <el-select style="width: 30%;" filterable v-model="hour" placeholder="请选择时长" :disabled="isedit">
            <el-option v-for="(item, index) in duration" :key="item.id" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex" v-if="hour == 4 || this.isUpdate">
      <el-form-item label="结束时间" prop="end_date" :label-width="formLabelWidth">
        <el-date-picker
            v-model="form.end_date"
            type="date"
            value-format="yyyy-MM-dd"
            range-separator="-"
            placeholder="开始日期"
            :disabled="isedit"/>
      </el-form-item>
        <el-form-item style="margin-left: 20px;" prop="end_time">
          <el-time-select
              @change="changeTime('end')"
              placeholder="起始时间"
              v-model="form.end_time"
              :picker-options="{
      start: '08:30',
      step: '00:15',
      end: '18:30'
    }">
          </el-time-select>

<!--          <el-time-picker v-model="form.end_time"
                          value-format="HH:mm:ss"
                          :picker-options="{
      selectableRange: '09:00:00 - 20:00:00'
    }"
                          placeholder="开始时间">
          </el-time-picker>-->
        </el-form-item>
      </div>
      <el-form-item label="会议纪要" prop="record" :label-width="formLabelWidth">
        <Editor v-if="!loading.dialog"  :content="form.record" @contentData="changeMeetingContent"
                :dialogVisibleModelType="form.id ? 'update' : 'create'" />
<!--
        <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="form.record" :disabled="isedit">
        </el-input>-->
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="!isedit"  style="margin-left:0;" :loading="loading.submit" type="warning" @click="onSubmit">提 交</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {Editor} from "@/components/index.js";
import moment from 'moment'
import {
  getDevOpsSpaceDetaileMeetingApi,
  postDevOpsSpaceAddMettingApi,
  postDevOpsSpaceUpdateMettingApi
} from "@/server/tops/devOps";
import {mapState} from "vuex";

export default {
  components: { Editor },
  props: {
    checkDataInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    tabid: {
      type: String,
      default: '',
    },
    stage : {
      default: '',
    },
    isedit: {
      default: false,
    },
    back: {
      type: String,
      default: '',
    },
    demandId:{
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    }
  },
  data() {
    return {
      form: {
        followerIds:[],
        demandId:'',
        type: '1',
        title: '',
        start_date: this.getNowDate(),
        start_time:'',
        end_date: this.getNowDate(),
        end_time:'',
      },
      rules: {
        title: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        type: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        leaderId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        stage: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        followerIds: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        start_date: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        start_time: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        end_date: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        end_time: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '140px',
      step: 1, // 1. 编辑 2. 提交
      loading: {
        dialog: false
      },
      dialog: {
      },
      username: '',
      duration:[
        {id:'0.5', name:'30分钟'},
        {id:'1', name:'一个小时'},
        {id:'2', name:'二个小时'},
        {id:'3', name:'三个小时'},
        {id:'4', name:'自定义'}
        ],
      hour: '',
    };
  },
  async created() {
    const { id = ''} = this.checkDataInfo;
    this.form = { ...this.form, id}
    if (id) await this.init();
    if (this.isCreate) {
      this.step = 2;
    };
    if(!id){
      this.form.stage = this.stage;
    }
    this.username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    if(!id){
      if(this.allUserList.ALLUSERIDLIST1[this.username]){
        let defauleaderId = this.allUserList.ALLUSERIDLIST1[this.username];
        this.form.leaderId = defauleaderId.toString();
      }
    }

    },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          meetingType: (state) => state.devOps.MEETINGTYPE,
          stageType: (state) => state.devOps.STAGETYPE,
          allUserList: (state) => state.devOps.ALLUSERLIST,
        }
    ),
    // 判断是否是创建
    isCreate() {
      const { id = ''} = this.formInfo || {};
      return !id;
    },
    isUpdate() {
      const { id = ''} = this.checkDataInfo || {};
      if(id) return true;
      return false;
    },
    newTitle() {
      if (this.form.id) {
        return '会议-' + this.form.title;
      } else {
        return '添加会议'
      }
    },
  },
  methods: {
    // 初始化页面
    async init() {
      await this.queryDevOpsSpaceMeetingDetail();
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    changeTime(type){
     /* if(type==='start' && this.form.start_date){
       // hour
        const initialTime = this.form.start_date + ' ' + this.form.start_time;
        // 将时间转换为moment对象
        let timeObj = moment(initialTime);
        let newTime = timeObj.add(60, 'minute');
        this.form.startTime = timeObj.format('YYYY-MM-DD HH:mm');
        //endTime
        console.log(initialTime)
        console.log(this.form.start_time);
        console.log(this.form.end_time);
        console.log(newTime);
        console.log("增加60分钟后的时间：", timeObj.format('YYYY-MM-DD HH:mm'));
      }
      if(type==='end'){
        console.log(this.form.start_time);
        console.log(this.form.end_time);
      }*/
    },

    changeDuration(val){
      if(val && val != 4 ){
        const initialTime = this.form.start_date + ' ' + this.form.start_time;
        // 将时间转换为moment对象
        let timeObj = moment(initialTime);
        let min = Number(val) * 60;
         timeObj.add(min, 'minute');
        return timeObj.format('YYYY-MM-DD HH:mm');
      }else{
        return false;
      }
    },
    // 获取会议详情
    async queryDevOpsSpaceMeetingDetail() {
      this.loading.dialog = true;
      try {
        const ret = await getDevOpsSpaceDetaileMeetingApi({
          id: this.checkDataInfo.id,
        });
        const info = ret.data[0] || {};
        let followersIds = [];
        for (let i = 0; i < info.followers.length; i++) {
          followersIds.push(info.followers[i].id.toString())
        }
        let startTime = info.startTime.split(' ');
        let endTime = info.endTime.split(' ');
        this.form = {
          ...this.form,
          ...info,
          leaderId: info.leader.id ? info.leader.id.toString() : '',
          stage: info.stage.toString(),
          type: info.type.toString(),
          followerIds: followersIds,
          start_date: startTime[0] ? startTime[0]: '',
          start_time: startTime[1] ? startTime[1]: '',
          end_date: endTime[0] ? endTime[0]: '',
          end_time: endTime[1] ? endTime[1]: '',

        };
      } catch (error) {
        this.$notify({
          message: error || "获取会议详情失败",
          type: "error",
        })
      } finally {
        this.loading.dialog = false;
      }
    },
    // 提交
    async onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if(this.hour && this.hour !=4){
          this.endTime = this.changeDuration(this.hour);
          this.form.end_date =  this.form.start_date;
          this.form.end_time = this.form.start_time;
        }
        if (valid) {
          if(!this.hour && !this.form.end_time){
            this.$notify({
              message: "请填写结束时间",
              type: "error",
            })
            return false;
          }
          try {
            this.form.startTime='';
            this.form.endTime='';
              if(this.form.start_date){
                this.form.startTime = this.form.start_date + ' ' + this.form.start_time+':00';
              }
              if(this.form.end_date){
                this.form.endTime = this.form.end_date + ' ' + this.form.end_time+':00';
              }
            if(this.hour && this.hour !=4){
              this.form.endTime = this.changeDuration(this.hour)+':00';
            }
            this.$set(this.loading, 'submit', true)
            this.form = {...this.form,demandId: this.demandId};
            const ret = this.isUpdate ? await postDevOpsSpaceUpdateMettingApi({...this.form,stage:Number(this.form.stage),type: Number(this.form.type),followerIds: this.form.followerIds.toString(),leaderId: Number(this.form.leaderId)}) : await postDevOpsSpaceAddMettingApi({...this.form,stage:Number(this.form.stage),type: Number(this.form.type),followerIds: this.form.followerIds.toString(),leaderId: Number(this.form.leaderId)});
            this.$notify({
              message: ret.message || "数据异常",
              type: ret.status === 'success' ? 'success' : "error",
            })
            this.hideDialogVisible();
          } catch (error) {
            this.$notify({
              message: error || "数据异常",
              type: "error",
            })
          } finally {
            this.loading.submit = false;
          }
        }
      })
    },
    // 修改富文本内容
    changeMeetingContent(val) {
      this.form.record = val;
    },
    // 格式化 props
    formatFormInfo(val) {
      if (val) {
        return val.split(',')
      }
      return []
    },
    changeDate() {
      this.$nextTick(() => {
        this.form.pett = this.form.plt
      })
    },
    // 关闭弹窗
    handleClose() {
      this.hideDialogVisible()
    },
  }
};
</script>
<style lang="scss">
.meet_model_dialog {
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }

  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;
      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .el-dialog__body {
    padding-bottom: 0;
  }

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
}
</style>
